/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Access_Grant_SuccessInputs */



/**
* | output |
* | --- |
* | "Access granted successfully." |
*
* @param {Project_Access_Grant_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_grant_success = /** @type {((inputs?: Project_Access_Grant_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Grant_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugriff erfolgreich gewährt.")
	return /** @type {LocalizedString} */ ("Access granted successfully.")
});